export default {
  DATE_FORMAT: 'YYYY-MM-DD HH:mm:ss',
  EMPTY: '—'
}
